export const generateColumns = (fields) => fields.map((column) => {
    var _a;
    return ({
        key: column.key.toString(),
        name: ((_a = column.label) === null || _a === void 0 ? void 0 : _a.toString()) || "",
        minWidth: 181,
    });
});
